import React from 'react';

export default class DynamicBreadcrumb {
    path: string;
    pageTitle?: string;
    pageDescription?: string;
    headerSubscript?: string;
    breadCrumb: string;
    headerActions?: React.ReactNode;

    constructor(
        path: string,
        breadCrumb: string,
        pageTitle?: string,
        pageDescription?: string,
        headerSubscript?: string,
        headerActions?: React.ReactNode
    ) {
        this.path = path;
        this.pageTitle = pageTitle;
        this.breadCrumb = breadCrumb;
        this.pageDescription = pageDescription;
        this.headerSubscript = headerSubscript;
        this.headerActions = headerActions;
    }
}